/** @publicapi @module ng1 */ /** */
import * as ng_from_import from 'angular';
/** @hidden */ var ng_from_global = angular;
/** @hidden */ export var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
//# sourceMappingURL=angular.js.map


//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/angular-ui-router/lib-esm/angular.js
// module id = 18
// module chunks = 0